import { ListboxOptions, ListboxOption } from "@headlessui/react";
import { Listbox } from "@headlessui/react";
import { FC, Fragment } from "react";
import { SpanIconCheckSelect } from "../atoms/SpanIconCheckSelect";

export type Option = { id: string | number | null; name: string };

export type OptionsSelectProps = {
  options: Option[];
};

export const OptionsSelect: FC<OptionsSelectProps> = ({ options }) => {
  return (
    <Fragment>
      <Listbox.Options
        as="div"
        className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      >
        {options.map((person, index) => (
          <Listbox.Option
            key={person.id ?? `fallback-${index}`}
            value={person}
            className="group relative cursor-default select-none py-2 pl-8 pr-4 text-gray-900 data-[focus]:bg-primary data-[focus]:text-white"
          >
            <span className="block truncate font-normal group-data-[selected]:font-semibold">
              {person.name}
            </span>
            <SpanIconCheckSelect />
          </Listbox.Option>
        ))}
      </Listbox.Options>
    </Fragment>
  );
};
